// extracted by mini-css-extract-plugin
export var dataCell = "_pq-2";
export var dataRow = "_pq-0";
export var headerRow = "_pq-1";